export default function ResetScroll() {
  window.scrollTo(0,0);
}
